export {environment} from './environment';
export {Ng2BingmapsDemoAppComponent} from './ng2-bingmaps-demo.component';
